<template>
  <div>
    <p class="level">
      <svgicon
        :name="icon"
        width="30"
        height="30"
        class="level-item">
      </svgicon>
      <span class="level-item">{{ title }}</span>
    </p>
    <pass-fail-icon :status="failCount === 0" :size="iconSize">
    </pass-fail-icon>
    <div class="numbers level">
      <p class="level-item">
          <span class="level">
            <svgicon
              name="alert_circle"
              width="20"
              height="20"
              :color="disabledColor"
              class="level-item">
            </svgicon>
            <span class="level-item counts">{{ failCount }}</span>
          </span>
      </p>
      <p class="level-item">
        <span class="level">
          <svgicon
            name="ok"
            width="20"
            height="20"
            :color="disabledColor"
            class="level-item">
          </svgicon>
          <span class="level-item counts">{{ passCount }}</span>
        </span>
      </p>
      <p class="level-item">
        <span class="level">
          <svgicon
            name="disabled"
            width="20"
            height="20"
            :color="disabledColor"
            class="level-item">
          </svgicon>
          <span class="level-item counts">{{ disabledCount }}</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import insights from '@/mixins/insights';
import PassFailIcon from '@/components/insights/PassFailIcon.vue';

export default {
  name: 'ScoreNumbers',
  mixins: [insights],
  components: { PassFailIcon },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconSize: {
      type: String,
      default: '65',
    },
    passCount: {
      type: Number,
      required: true,
    },
    failCount: {
      type: Number,
      required: true,
    },
    disabledCount: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
p.level {
  margin-bottom: 0;
}

.counts {
  color: #CCC;
}

.numbers {
  font-size: 0.8rem;
}
</style>
